

import e from './style.module.css';

export const SkeProducts = (props:any) => (
 
  <ul className={`${e['o-vertical-spacing']} ${e['o-vertical-spacing--l']}`}>
    <li className={e["blog-post o-media"]}>
      <div>
        <div className='text-center text-lg-start'>
          <p>
            <span className={`${e['skeleton-box']} ${e.span1}`}></span>
            <span className={`${e['skeleton-box']} ${e.span2}`}></span>
            <span className={`${e['skeleton-box']} ${e.span3}`}></span>
            <span className={`${e['skeleton-box']} ${e.span4}`}></span>
          </p>
        </div>
      </div>
    </li>
  </ul>
)



 